import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import CancelIcon from "@mui/icons-material/Cancel";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from "../Includes/Header";
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import DeviceEnrollDialog from "../../components/DeviceEnroll/DeviceEnrollDialog";
import { useEffect, useRef } from "react";
import { DialogContentText } from "@mui/material";
import { EditText } from 'react-edit-text';
import 'react-edit-text/dist/index.css';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // Example icon

import {
  Card,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Menu from "@mui/material/Menu";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import {
  AutocompleteAdminUser,
  StatusAdminUser,
} from "../Apihelper/ApiHelperUser";
import {
  retrieveOfferMember,
  DeleteOfferpackageUser,
  UpdateOfferpackageUser,
  DueOfferpackageUser,
  AutocompleteNonUser,
} from "../Apihelper/ApiOfferPackage";

import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';
import PayButton from "../../components/PayButton/PayButton";

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '0.875rem',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f8fafc',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#ffffff',
  },
  '&:hover': {
    backgroundColor: '#f1f5f9',
    transition: 'background-color 0.2s ease',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  minWidth: '32px',
  padding: '4px 8px',
}));

function OfferPackageMember(props) {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [status, setstatus] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [Role, setRole] = useState("");
  const [openToast, setOpenToast] = useState(false);
  const [options, setOptions] = useState([]);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const [fetchdatarow, setetchdatarow] = useState([]); // Default to 'success'
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const dateRef = useRef();
  const [age, setAge] = React.useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [bioOpen, setBioOpen] = useState(false);
  const [opendue, setOpendue] = useState(false);
  const [selectedDue, setSelectedDue] = useState(null); // To store the current due value for the modal
  const [inputValue, setInputValue] = useState(''); // Input value in modal
  const [currentRowId, setCurrentRowId] = useState(null); // To store the current row id for handling due change

  // Open modal if due is greater than 0
  const handleOpendue = (id, due) => {
    if (due > 0) {
      setOpendue(true);
      setSelectedDue(due);
      setCurrentRowId(id);
    }
  };
  // Close modal

  const handleClosedue = () => {
    setOpendue(false);
    setInputValue('');
  };
  // Handle input change
  const handleInputChangedue = (event) => {
    let value = event.target.value;

    // Ensure the value is within the allowed range (min = 0, max = selectedDue)
    if (value > selectedDue) {
      value = selectedDue; // Limit the value to the maximum (due amount)
    } else if (value < 0) {
      value = 0; // Prevent negative values
    }

    setInputValue(value);
  };

  // Handle submit
  const handleSubmit = () => {
    handleDueChange(currentRowId, inputValue); // Call the API function with the new value
    handleClosedue();
  };

  const [editedData, setEditedData] = useState({
    id: "",
    name: "",
    email: "",
    phone: "",
    card_number: "",
    membership_number: "",
  });
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);


  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );

  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }

  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  // useEffect(() => {
  //   // Perform localStorage action
  //   const item = localStorage.getItem('userdata')
  //   if (item ==null){
  //      setredirectpage(true);
  //   }
  //   //console.log("tapan"+item);
  // }, [])
  // if (redirectpage) {

  //   return redirect('/');
  // }



  const handleToggle = (id, status) => {
    setOpenConfirmation(true);
    const newStatus = status === 1 ? 0 : 1;
    setstatus(newStatus);
    setDeleteConfirmationId(id);
    setIsActive(newStatus === 0);
  };

  const handleConfirm = async () => {
    // setIsActive(!isActive);
    // setOpenConfirmation(false);

    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;

      const res = await StatusAdminUser(
        userToken,
        userId,
        status,
        deleteConfirmationId
      );

      if (res.code == "200") {
        handleSnackbarOpen(res.message, "success");
        setIsActive(!isActive);
        setOpenConfirmation(false);
        setOpenDeleteConfirmation(false);
        fetchData();
      } else {
        handleSnackbarOpen(res.message, "error");
        //  console.error(error); // Handle error
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  const handleCancel = () => {
    setOpenConfirmation(false);
  };
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [dueValues, setDueValues] = useState([]); // Initialize state for due values
  const [adddueValues, setaddDueValues] = useState([100, 50, 75]);
 
  const fetchData = async (value = "") => {
    setLoading(true);
    setHasMore(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; // Assuming you have a userId in userdata
      const searchText = value; // Example search text
      const limit = 10; // Example limit
      const index = 0; // Example index
      const res = await retrieveOfferMember(
        userToken,
        userId,
        searchText,
        limit,
        index
      );

      if (res.code == "200") {
        setetchdatarow(res.data);
        setDueValues(res.data.map(row => row.due)); // Extract 'due' from each row


        console.log(res.data);
        setLoading(false);
      } else {
        // console.error(error); // Handle error
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleLoadMore = async () => {
    // Calculate the next index based on the number of items loaded so far
    const nextIndex = fetchdatarow.length;

    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);

    try {
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const searchText = "";
      const limit = 10;

      const res = await retrieveOfferMember(
        userToken,
        userId,
        searchText,
        limit,
        nextIndex
      );

      if (res.code == "200") {
        // Append the newly loaded data to the existing data
        setetchdatarow((prevResults) => [...prevResults, ...res.data]);
        setDueValues((prevDueValues) => [
          ...prevDueValues,
          ...res.data.map(row => row.due) // Extract 'due' from the new rows
        ]);
        // Check if there are more results available
        if (res.data.length >= 0 && res.data.length < 10) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSearchChange = (event, value) => {
    const searchText = value || ""; // If value is undefined or empty, set searchText to empty string
    // setSearchText(searchText);
    // Call fetchData function here with the updated searchText
    fetchData(searchText);
  };

  const handleDelete = (id) => {
    handleClose();
    setDeleteConfirmationId(id);
    setOpenDeleteConfirmation(true, id);
  };
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate('/');
    }
    
  }, []);
  const handleConfirmDelete = async (id) => {
    // setSnackbarMessage('package deleted successfully');
    // setSnackbarSeverity('error');
    // setOpenDeleteConfirmation(false);
    // setOpenToast(true); // Show toast message

    if (deleteConfirmationId !== null) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id;

        const res = await DeleteOfferpackageUser(
          userToken,
          userId,
          deleteConfirmationId
        );

        if (res.code == "200") {
          handleSnackbarOpen(res.message, "success");
          setOpenDeleteConfirmation(false);
          fetchData();
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };

  const handleCancelDelete = () => {
    setOpenDeleteConfirmation(false);
  };
  const handleInputChange = async (value) => {
    if (value.length >= 3) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata
        const searchText = value; // Example search text

        const res = await AutocompleteNonUser(userToken, userId, searchText);

        if (res.code == "200") {
          const names = res.data.map((item) => item.search_text);
          setOptions(names);
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };
  const handleEditModalOpen = (row) => {
    setEditedData({
      id: row.id,
      name: row.name || "",
      email: row.email || "",
      phone: row.phone || "",
      card_number: row.card_number || "",
      membership_number: row.membership_number || "",
    });
    setEditModalOpen(true);
  };

  const handleEditModalClose = () => {
    setEditModalOpen(false);
  };

  const handleEditFieldChange = (field) => (event) => {
    setEditedData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleEditSubmit = async () => {
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;

    try {
      const res = await UpdateOfferpackageUser(userToken, editedData);

      if (res.code == "200") {
        handleSnackbarOpen(res.message, "success");
        setEditedData({
          id: "",
          name: "",
          email: "",
          phone: "",
          card_number: "",
          membership_number: "",
        });
        fetchData();
      } else {
        handleSnackbarOpen(res.message, "error");
      }
    } catch (error) {
      console.error(error);
    }

    setEditModalOpen(false);
  };

  const handleRoleChange = (event) => {
    setRole(event.target.value);
  };

  const handleDueChange = async (id,value) => {
    const updatedValues = dueValues.map((due, index) => (index === id - 1 ? value : due));
    setaddDueValues(updatedValues);
   
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id;

        const res = await DueOfferpackageUser(
          userToken,
          userId,
          id,
          value
        );

        if (res.code == "200") {
          handleSnackbarOpen(res.message, "success");
          // setOpenDeleteConfirmation(false);
          fetchData();
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
   
  };

  return (
    <Box>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', sm: 'row' }, 
        justifyContent: 'space-between',
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: 2,
        mb: 3
      }}>
        <Box flex={1} sx={{ width: { xs: '100%', sm: 'auto' } }}>
              <Autocomplete
                freeSolo
                disableClearable
                options={options}
            onInputChange={(event, value) => handleInputChange(value)}
                onChange={(event, value) => handleSearchChange(event, value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                label="Search members"
                    size="small"
                    sx={{
                  width: '100%',
                  maxWidth: { sm: 300 },
                  backgroundColor: '#ffffff',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#e2e8f0',
                    },
                    '&:hover fieldset': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: appColors.evergreen,
                    },
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                  type: 'search',
                    }}
                  />
                )}
              />
            </Box>

        <Button
          variant="contained"
          startIcon={<ControlPointIcon />}
          onClick={() => navigate('/addnonmember')}
              sx={{
            bgcolor: appColors.evergreen,
            '&:hover': {
              bgcolor: appColors.pine,
            },
            textTransform: 'none',
            fontWeight: 600,
            width: { xs: '100%', sm: 'auto' }
          }}
        >
          Add Member
        </Button>
      </Box>

      <Paper
        elevation={0}
                        sx={{
          borderRadius: 2,
          overflow: { xs: 'auto', sm: 'hidden' },
          bgcolor: '#ffffff',
          boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
        }}
      >
        {loading ? (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            p: 4 
          }}>
            <CircularProgress sx={{ color: appColors.evergreen }} />
          </Box>
        ) : (
          <TableContainer sx={{ 
            maxWidth: '100%',
            overflowX: 'auto'
          }}>
            <Table sx={{ 
              minWidth: { xs: 'auto', sm: 650 }
            }} size="medium">
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{ width: '50px' }}>#</StyledTableCell>
                  <StyledTableCell>Member Name</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Package Name</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Value</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Due</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Payment Date</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Start Date</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>End Date</StyledTableCell>
                  <StyledTableCell align="right" sx={{ width: '100px' }}>Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fetchdatarow.map((row, index) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>
                      <Box>
                        <Typography variant="subtitle2" sx={{ color: appColors.evergreen, fontWeight: 600 }}>
                          {row.name}
                        </Typography>
                        <Typography 
                          variant="body2" 
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            color: '#64748b'
                        }}
                      >
                          {row.package_name} • ₹{row.paying_amount}
                        </Typography>
                        <Typography 
                          variant="body2" 
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            color: row.due > 0 ? '#dc2626' : '#16a34a',
                            mt: 0.5
                          }}
                        >
                          Due: ₹{row.due}
                        </Typography>
                        {row.payment_date && (
                          <Typography
                            variant="body2"
                            sx={{ display: { xs: 'block', sm: 'none' }, color: '#64748b', mt: 0.5 }}
                          >
                            Payment: {row.payment_date}
                          </Typography>
                        )}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{row.package_name}</StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>₹{row.paying_amount}</StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                      <Button
                        variant="text"
                        onClick={() => handleOpendue(row.id, row.due)}
                        startIcon={<AttachMoneyIcon />}
                        sx={{
                          color: row.due > 0 ? '#dc2626' : '#16a34a',
                          '&:hover': {
                            bgcolor: row.due > 0 ? '#fef2f2' : '#f0fdf4',
                          },
                          textTransform: 'none',
                          fontWeight: 600,
                        }}
                      >
                        ₹{row.due}
                      </Button>
                    </StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                      {row.payment_date || "—"}
                    </StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{row.start_date}</StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{row.end_date}</StyledTableCell>
                    <StyledTableCell align="right">
                      <ButtonGroup 
                        variant="outlined" 
                        size="small"
                        sx={{
                          '& > button': {
                            borderColor: '#e2e8f0',
                          }
                        }}
                      >
                        <ActionButton
                          onClick={() => handleEditModalOpen(row)}
                        sx={{
                            color: appColors.evergreen,
                            '&:hover': {
                              bgcolor: '#f0fdf4',
                              borderColor: appColors.evergreen,
                          },
                        }}
                      >
                          <EditIcon fontSize="small" />
                        </ActionButton>
                        <ActionButton
                          onClick={() => handleDelete(row.id)}
                        sx={{
                            color: '#dc2626',
                            '&:hover': {
                              bgcolor: '#fef2f2',
                              borderColor: '#dc2626',
                          },
                        }}
                      >
                          <DeleteIcon fontSize="small" />
                        </ActionButton>
                      </ButtonGroup>
                    </StyledTableCell>
                  </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
            </TableContainer>
        )}
      </Paper>

      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        mt: 3,
        mb: 3 
      }}>
              <Button
                variant="contained"
                onClick={handleLoadMore}
          disabled={!hasMore || (fetchdatarow.length < 10 && fetchdatarow.length !== 0)}
          sx={{
            bgcolor: appColors.evergreen,
            '&:hover': {
              bgcolor: appColors.pine,
            },
            '&.Mui-disabled': {
              bgcolor: '#94a3b8',
              color: '#ffffff',
            },
            minWidth: '150px',
            height: '40px',
            textTransform: 'none',
            fontWeight: 600,
          }}
              >
          {fetchdatarow.length === 0 || fetchdatarow.length < 10 ? 'No More Records' : 'Load More'}
              </Button>
      </Box>

      <Dialog
        open={openDeleteConfirmation}
        onClose={handleCancelDelete}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: '#dc2626', fontWeight: 600 }}>
          Delete Member
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this member?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button
            onClick={handleCancelDelete}
            sx={{
              color: '#64748b',
              '&:hover': {
                bgcolor: '#f1f5f9',
              },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            sx={{
              bgcolor: '#dc2626',
              '&:hover': {
                bgcolor: '#b91c1c',
              },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={opendue}
        onClose={handleClosedue}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: appColors.evergreen, fontWeight: 600 }}>
          Update Due Amount
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              label="Due Amount"
              type="number"
              value={inputValue}
              onChange={handleInputChangedue}
              fullWidth
              InputProps={{
                startAdornment: <AttachMoneyIcon sx={{ color: '#64748b', mr: 1 }} />,
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: appColors.evergreen,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.evergreen,
                  },
                },
              }}
            />
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
              Maximum due amount: ₹{selectedDue}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button
            onClick={handleClosedue}
            sx={{
              color: '#64748b',
              '&:hover': {
                bgcolor: '#f1f5f9',
              },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <PayButton overlay
            onClick={handleSubmit}
            variant="contained"
            sx={{
              bgcolor: appColors.evergreen,
              '&:hover': {
                bgcolor: appColors.pine,
              },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Update
          </PayButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={editModalOpen}
        onClose={handleEditModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: appColors.evergreen, fontWeight: 600 }}>
          Edit Member
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Name"
              fullWidth
              value={editedData.name}
              onChange={handleEditFieldChange('name')}
            />
            <TextField
              label="Phone"
              fullWidth
              value={editedData.phone}
              onChange={handleEditFieldChange('phone')}
            />
            <TextField
              label="Email"
              fullWidth
              value={editedData.email}
              onChange={handleEditFieldChange('email')}
            />
            <TextField
              label="Card Number"
              fullWidth
              value={editedData.card_number}
              onChange={handleEditFieldChange('card_number')}
            />
            <TextField
              label="Membership Number"
              fullWidth
              value={editedData.membership_number}
              onChange={handleEditFieldChange('membership_number')}
            />
            <Typography variant="caption" color="text.secondary">
              Package and payment details cannot be edited here.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button
            onClick={() => setBioOpen(true)}
            variant="outlined"
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Machine biometrics
          </Button>
          <Button
            onClick={handleEditModalClose}
            sx={{
              color: '#64748b',
              '&:hover': { bgcolor: '#f1f5f9' },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleEditSubmit}
            variant="contained"
            sx={{
              bgcolor: appColors.evergreen,
              '&:hover': { bgcolor: appColors.pine },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <DeviceEnrollDialog
        open={bioOpen}
        token={(() => { try { return JSON.parse(localStorage.getItem("userdata")).token; } catch (e) { return ""; } })()}
        personType="nonregister"
        personId={editedData.id}
        personName={editedData.name}
        onClose={() => setBioOpen(false)}
      />
      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>
  );
}

export default OfferPackageMember;
